import { goSolidApi } from "@/composables/useGoSolidApi";
import type {
  SolderaRegistryAccountsResponse,
  GoReceiveOrderRequest,
  GoReceiveOrderResponse,
} from "@/dashboard/inventory_management/company_orders/types/virtualAccountTypes";

/**
 * API functions for hosted account functionality.
 */

/**
 * Fetch available Soldera registry accounts for hosted receiving.
 */
export const fetchSolderaRegistryAccounts =
  async (): Promise<SolderaRegistryAccountsResponse> => {
    const response = await goSolidApi.get<SolderaRegistryAccountsResponse>(
      "/api/registry/soldera-accounts"
    );
    return response.data;
  };

/**
 * Create a hosted account receive order.
 */
export const createReceiveOrder = async (
  companyId: number,
  orderData: GoReceiveOrderRequest
): Promise<GoReceiveOrderResponse> => {
  const response = await goSolidApi.post<GoReceiveOrderResponse>(
    `/api/company/${companyId}/portfolio/receive`,
    orderData
  );
  return response.data;
};
